<template>
  <div class="mod-login">
    <div class="form-box">
      <div class="title">趣智营销商业开放平台-邮箱登录</div>
      <el-input
        v-model="email"
        placeholder="请输入账户名称"
        class="form-account"
        type="email"
      >
        <i 
          slot="prefix" 
          class="icon icon-account"
        />
      </el-input>
      <el-input
        v-model="pwd"
        placeholder="请输入密码"
        class="form-pwd"
        show-password
      >
        <i 
          slot="prefix" 
          class="icon icon-lock"
        />
      </el-input>
      <div class="code-box">
        <el-input
          v-model="code"
          placeholder="请输入验证码"
          class="form-code"
          :maxlength="4"
        >
          <i 
            slot="prefix" 
            class="icon icon-key"
          />
        </el-input>
        <a
          v-if="codeImage"
          class="icon-code"
          @click="changeCodeImage"
        >
          <img 
            class="code-image" 
            :src="codeImage" 
          >
        </a>
      </div>
      <a 
        class="btn-item"
        @click="login"
      >
        登 录
      </a>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui';
import { getLoginCode, doLogin, loginStatus } from '@/service';
import Cookie from 'js-cookie'

export default {
  data() {
    return {
      email: '',
      pwd: '',
      code: '',
      codeImage: '',
    };
  },
  created() {
    this.getCodeImage();
  },
  methods: {
    showMessage(config) {
      Message.closeAll();
      Message({
        showClose: true,
        duration: 3000,
        offset: 100,
        ...config,
      });
    },
    async getCodeImage() {
      let blob = await getLoginCode();
      let reader = new FileReader();
      let me = this;
      reader.onload = function (e) {
        me.codeImage = e.target.result;
      };
      reader.readAsDataURL(blob);
    },
    async doLogin() {
      Cookie.remove('MK_USER_ID', {path: '/', domain: '.aiclk.com'});
      Cookie.remove('NAGATO_PROOF', {path: '/', domain: '.aiclk.com'});
      let res = await doLogin({
        type: 1,
        email: this.email,
        password: this.pwd,
        code: this.code,
      });
      if (res.code === 200) {        
        // this.$router.push('appmanage');
        let res2 = await loginStatus({});
        if (res2.code === 200) {
          this.$router.push('appmanage');
        } else {
          this.$message.error(res2.message);
        }
      } else {
        this.showMessage({
          message: res.message,
          type: 'error',
          showClose: true,
          duration: 3000,
          offset: 100,
        });
      }
    },
    changeCodeImage() {
      this.getCodeImage();
    },
    login() {
      let message = '';
      if (!this.email) {
        message = '请输入账号';
      } else if (!this.pwd) {
        message = '请填写密码';
      } else if (!this.code || this.code.length !== 4) {
        message = '请正确填写验证码';
      }
      if (message) {
        this.showMessage({
          message,
          type: 'error',
        });
        return;
      }
      this.doLogin();
    },
  },
};
</script>

<style lang="scss">
.mod-login {
  .el-input__inner {
    padding-left: 42px;
    background: rgba(0, 0, 0, 0);
  }
}
</style>

<style lang="scss" scoped>
.mod-login {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url('./images/bg_login.png');
  background-size: cover;
  background-repeat: no-repeat;
  .el-input__inner {
    padding-left: 42px;
    background: rgba(0, 0, 0, 0);
  }
  .form-box {
    width: 400px;
    height: 450px;
    padding: 0 30px 47px;
    box-sizing: border-box;
    border-radius: 4px;
    background: #fff;
    border: 1px solid #d9d9d9;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    .title {
      height: 78px;
      text-align: center;
      line-height: 78px;
      border-bottom: 2px solid #e6e6e6;
      font-size: 20px;
      color: $primary-color;
    }
    .form-account {
      margin-top: 50px;
      background-color: #f7f8fa;
    }
    .form-pwd {
      margin-top: 20px;
      background-color: #f7f8fa;
    }
    .code-box {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      .form-code {
        background-color: #f7f8fa;
      }
      .icon-code {
        display: inline-block;
        width: 120px;
        height: 40px;
        box-sizing: border-box;
        margin-left: 9px;
        border-radius: 4px;
        background-color: #f7f8fa;
        background-size: contain;
        border: 1px solid $border-color;
        cursor: pointer;
      }
    }
    .icon {
      display: inline-block;
      width: 11px;
      height: 12px;
      padding-left: 10px;
      margin-top: 14px;
      background-size: 11px 12px;
      background-position: 10px center;
      background-repeat: no-repeat;
      &.icon-account {
        background-image: url('./images/icon_account.svg');
      }
      &.icon-lock {
        background-image: url('./images/icon_lock.svg');
      }
      &.icon-key {
        background-image: url('./images/icon_key.svg');
      }
    }
    .btn-item {
      display: block;
      width: 100%;
      height: 40px;
      margin-top: 50px;
      line-height: 40px;
      text-align: center;
      border-radius: 4px;
      background: $primary-color;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
    }
  }
}
</style>